module.exports = __webpack_public_path__ + "media/images/icons/bootstrap-icons-495fbb552750fbb177bc10ad83f21feb.svg";